import { FC } from "react";
import { useTranslation } from "react-i18next";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import styles from "./ViewerNativoIndisponivelModal.module.scss";

interface IViewerNativoIndisponivelModal {
  visible: boolean;
  /** O navegador não tem WebGPU: o arquivo nem chegou a ser tentado aqui. */
  noWebGPU?: boolean;
  /** Conversão Autodesk de um arquivo que o nosso viewer abre: só o aceite do gasto. */
  autodeskConversion?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * O nosso viewer 3D não abre o arquivo (backend recusou o motor nativo, o motor
 * falhou ou o navegador não tem WebGPU): a conversão Autodesk é paga, então
 * quem escolhe é o usuário.
 */
const ViewerNativoIndisponivelModal: FC<IViewerNativoIndisponivelModal> = ({
  visible,
  noWebGPU,
  autodeskConversion,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation(['listagemArquivos', 'common']);

  return (
    <Modal
      title={autodeskConversion
        ? t('listagemArquivos:nativeViewerUnavailable.autodeskConversionTitle')
        : t('listagemArquivos:nativeViewerUnavailable.title')}
      width={487}
      visible={visible}
      onCancel={onClose}
      footerButtons={
        <div className={styles['footer-buttons']}>
          <Button onClick={onClose} className={styles['cancel-button']}>
            {t('common:cancel')}
          </Button>
          <Button
            type="primary"
            onClick={onConfirm}
            className={styles['confirm-button']}
          >
            {t('listagemArquivos:nativeViewerUnavailable.confirm')}
          </Button>
        </div>
      }
    >
      <div className={styles['main-wrapper']}>
        {!autodeskConversion && (
          <p>
            {noWebGPU
              ? t('listagemArquivos:nativeViewerUnavailable.noWebGPUMessage')
              : t('listagemArquivos:nativeViewerUnavailable.message')}
          </p>
        )}
        <p>{t('listagemArquivos:nativeViewerUnavailable.question')}</p>
      </div>
    </Modal>
  );
};

export default ViewerNativoIndisponivelModal;
